  $(document).ready(function() {
    // Initialize Shop Discounts Swiper
    if ($('.brands-swiper').length) {
      const brandsSwiper = new Swiper('.brands-swiper', {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
          nextEl: '.brands-next',
          prevEl: '.brands-prev',
        },
        pagination: {
          el: '.brands-pagination',
          clickable: true,
        },
        speed: 600,
        effect: 'slide',
        loop: false
      });
    }
  });

  // Global function to toggle shop discounts visibility
  function toggleShopDiscounts(targetSlideIndex = 0) {
    const $discountsSection = $('#shop-discounts-section');
    const $ctaBtns = $('.activities-cta-btn');
    
    if ($discountsSection.length) {
      if ($discountsSection.css('display') === 'none') {
        $discountsSection.show();
        
        // Scroll to the discounts section
        $('html, body').animate({
          scrollTop: $discountsSection.offset().top - 45
        }, 500);
        
        // Update button text to show it's active
        $ctaBtns.each(function() {
          const $btn = $(this);
          if (!$btn.data('originalText')) {
            $btn.data('originalText', $btn.text());
          }
          $btn.text('View list below');
        });
        
        // Initialize swiper if not already initialized
        setTimeout(() => {
          if ($('.brands-swiper').length && typeof Swiper !== 'undefined') {
            // Destroy existing swiper if it exists
            const existingSwiper = $('.brands-swiper')[0]?.swiper;
            if (existingSwiper) {
              existingSwiper.destroy(true, true);
            }
            
            const brandsSwiper = new Swiper('.brands-swiper', {
              slidesPerView: 1,
              spaceBetween: 0,
              navigation: {
                nextEl: '.brands-next',
                prevEl: '.brands-prev',
              },
              pagination: {
                el: '.brands-pagination',
                clickable: true,
                dynamicBullets: false,
                renderBullet: function (index, className) {
                  return '<span class="' + className + '"></span>';
                }
              },
              speed: 600,
              effect: 'fade',
              loop: false,
              watchSlidesProgress: true,
              observer: true,
              observeParents: true,
              on: {
                init: function () {
                  this.update();
                  // Slide to target index after init
                  if (targetSlideIndex > 0 && targetSlideIndex < this.slides.length) {
                    this.slideTo(targetSlideIndex);
                  }
                },
                slideChange: function () {
                  // Update pagination manually if needed
                  this.pagination.update();
                }
              }
            });
          }
        }, 100);
      } else {
        $discountsSection.hide();
        
        // Restore original button text
        $ctaBtns.each(function() {
          const $btn = $(this);
          const originalText = $btn.data('originalText');
          if (originalText) {
            $btn.text(originalText);
          }
        });
      }
    }
  }